import React from 'react'
import { t } from 'ttag'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  getRespondent,
  getPersonality,
  getInterest,
  getGMA,
} from 'ducks/respondent'
import {
  toQuiz as toQuizRoute,
  toPersonalityQuiz,
  toInterestQuiz,
} from 'ducks/router'
import { ProcessingSpeed } from 'components/modals/TestsReportModal/tabs/ProcessingSpeed/ProcessingSpeed'
import styles from './AbilityResults.module.scss'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'
import PlayIcon from 'assets/icons/play.svg'
import BackIcon from 'assets/icons/back-arrow.svg'
import BackIconWhite from 'assets/icons/back-arrow-white.svg'
import { MailHint } from 'components/quiz/Quiz/Quiz'
import { hasModule, type Plan } from 'components/quiz/Quiz/plan'

type AbilityResultsState = {
  name?: string
  id?: string
  scores?: any
  stats?: any
  language?: string
  personalityStatus?: string
  interestStatus?: string
  is_job_seeker?: boolean
  plan?: Plan
}

const selectResults = (state): AbilityResultsState => {
  const personalityState = getPersonality(state)
  const interestState = getInterest(state)

  return {
    ...getGMA(state),
    ...getRespondent(state),
    personalityStatus: personalityState.status,
    interestStatus: interestState.status,
  }
}

const AbilityResults = () => {
  const {
    name,
    id: uuid,
    scores,
    stats,
    language,
    personalityStatus,
    interestStatus,
    is_job_seeker,
    plan,
  } = useSelector(selectResults, shallowEqual)
  const dispatch = useDispatch()
  const toQuiz = uuid => dispatch(toQuizRoute({ uuid }))
  const toPersonality = uuid => dispatch(toPersonalityQuiz({ uuid }))
  const toInterest = uuid => dispatch(toInterestQuiz({ uuid }))

  const personalityIsNext =
    hasModule(plan, 'personality') && personalityStatus !== 'completed'
  const isInterestCompleted = interestStatus === 'completed'

  const response = [{ name, scores, stats, id: uuid }]

  return (
    <div className={styles.abilityResults}>
      <div className={styles.title}>{t`Ability test results`}</div>
      <ProcessingSpeed
        factor={'GMA'}
        key={'GMA'}
        language={language}
        response={response}
        candidates={response}
        isCandidate
        isGreyBackground
      />
      <div className={styles.bottomBar}>
        <div className={styles.buttons}>
          <BoldButton
            label={t`Back to intro page`}
            icon={personalityIsNext ? BackIcon : BackIconWhite}
            isIconFirst
            isPrimary={!personalityIsNext}
            onClick={() => toQuiz(uuid)}
          />
          {personalityIsNext ? (
            <BoldButton
              label={t`Go to personality test`}
              icon={PlayIcon}
              isIconFirst
              onClick={() => toPersonality(uuid)}
            />
          ) : is_job_seeker && !isInterestCompleted ? (
            <BoldButton
              label={t`Go to interest test`}
              icon={PlayIcon}
              isIconFirst
              onClick={() => toInterest(uuid)}
            />
          ) : null}
        </div>
        <MailHint />
      </div>
    </div>
  )
}

export default AbilityResults
